import Vue from 'vue'
import Vuex from 'vuex'
import camelCase from 'lodash/camelCase'

import actions from './global/actions'
import getters from './global/getters'
import state from './global/state'
import mutations from './global/mutations'

Vue.use(Vuex)

const requireModules = require.context('./modules', false, /\.js$/)
const modules = {}

requireModules.keys().forEach((fileName) => {
  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''))

  modules[moduleName] = requireModules(fileName).default
})

const store = new Vuex.Store({
  modules,
  actions,
  getters,
  mutations,
  state
})

export default store
